import React, { Component, Fragment, useRef, UseEffect } from "react";
import styled from "styled-components";
import ReactButton from "common-components/Buttons";
import { media, isMobile } from "utils/style";
import CommonContainer from "common-components/Container";
// import { Input as ReactInput, Label as CommonLabel, Select as ReactSelect } from "@vzrf/react-forms";
import { Input } from "@vds/inputs";
import { TitleLockup } from "@vds/type-lockups";
import { Feature,Body,Title } from "@vds/typography"
import { DropdownSelect } from "@vds/selects";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { convertStringToElements } from "@vds/html-parsers";
import { Redirect } from "react-router-dom";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import { setA11yContent } from "../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import FetchPageContent from "../../../hoc/FetchPageContent";
import Warning from "../../../../assets/svgs/Warning.svg";
import { createUpdateProfile, addressDobUpdate } from "./actions/commonFormerCustomerAPI";
import moment from "moment";
import Alert from "common-components/Alert";



class FormerCustomerDetails extends Component {
  

  state = {
    firstname: "",
    lastname: "",
    streetaddress: "",
    apartment: "",
    city: "",
    state: "",
    zipcode: "",
    dob: "",
    checkbox: false,
    error: false,
    dateFormat: false
  };
  

  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("Address Details", this.props.pageContent.sc_pagetitle);
    }
  }

  onChangeText = (e) => {
    var name = e.target.name
    if (name == "dob") {
      this.setState({
        dateFormat: false,
      })
    }
    this.setState({ [name]: e.target.value.replace(/[^\w\s/@#$%^&\-\*():;"?_|.,+=!|\\]/gi, "") }, () => {
      if (this.state.dob.length == 10) {
        if (((!moment(this.state.dob, 'MM/DD/YYYY', true).isValid())) || (!moment(this.state.dob).isBefore(moment(), "day")) || (!(moment(this.state.dob, 'MM/DD/YYYY').isAfter('12/31/1899')))) {
          this.setState({
            errorMsg: "Enter Valid ",
            dateFormat: true
          })
        }
      }

    });
  };

  handleKeyPress = e => {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      e.preventDefault();
      return false;
    }
    return true;
  };

  handleClick() {
    let { firstname, lastname, streetaddress, apartment, city, state, zipcode, dob } = this.state
    let { location, formerId, caseId, uuid } = this.props
    if ((location.state.data.fname != null && location.state.data.lname != null  && streetaddress != ""
      && city != "" && state != "" && zipcode != "" && dob != "" && zipcode.length === 5)
      || ((location.state.data.isOptOut === "Y" || location.state.data.serviceType === "guest") && firstname != "" && lastname != "" != "" && streetaddress != ""
        && city != "" && state != "" && zipcode != "" && dob != "" && zipcode.length === 5)) {
      if ((moment(this.state.dob, 'MM/DD/YYYY', true).isValid() || moment(this.state.dob, 'M/D/YY', true).isValid()) && (moment(this.state.dob).isBefore(moment(), "day")) && (moment(this.state.dob, 'MM/DD/YYYY').isAfter('12/31/1899'))) {
        var datas = {
          emailId: location.state.data.emailId,
          firstName: location.state.data.fname ? location.state.data.fname : this.state.firstname ? this.state.firstname : "",
          lastName: location.state.data.lname ? location.state.data.lname : this.state.lastname ? this.state.lastname : "",
          consent: "No",
          streetAddress: this.state.streetaddress,
          aptOrSuiteOrFloor: this.state.apartment,
          zipCode: this.state.zipcode,
          city: this.state.city,
          state: this.state.state,
          action: location.state.data.currentIntent,
          flow: "billingUpdate",
          uuid: uuid,
          serviceType: location.state.data.serviceType,
          formerId: formerId,
          accountId: this.props.accountInfo
        }
        this.props.createUpdateProfile(datas).then(() => {
          let intent = location.state.data.currentIntent === "delete" ? "Delete" :
            location.state.data.currentIntent === "correct" ? "Correct" :
              location.state.data.currentIntent === "download" ? "Download" : ""
          if (!this.props.error) {
            var addressDobData = {
              "caseId": caseId,
              "intent": intent ? intent : null,
              "email": location.state.data.emailId,
              "dob": this.state.dob ? moment(this.state.dob, 'MM-DD-YYYY').format("MM/DD/YYYY") : null,
              "addressLine1": this.state.streetaddress ? this.state.streetaddress : null,
              "addressLine2": this.state.apartment ? this.state.apartment : null,
              "city": this.state.city ? this.state.city : null,
              "state": this.state.state ? this.state.state : null,
              "zipCode": this.state.zipcode ? this.state.zipcode : null,
              "FirstName": location.state.data.fname ? location.state.data.fname : this.state.firstname ? this.state.firstname : "",
              "lastName": location.state.data.lname ? location.state.data.lname : this.state.lastname ? this.state.lastname : "",
              "isOptOut": location.state.data.isOptOut ? location.state.data.isOptOut : null,
              "serviceType": location.state.data.serviceType ? location.state.data.serviceType : null,
              "formerId": formerId ? formerId : null
            }
            this.props.addressDobUpdate(addressDobData).then(() => {
              if (!this.props.error) {
                if (location.state.data.currentIntent === "delete" || location.state.data.currentIntent === "correct") {
                  this.props.history.replace(
                    {
                      pathname: "verify-identity",
                      state: { data: location.state.data ? location.state.data : null }
                    }
                  );
                } else {
                  this.props.history.replace(
                    {
                      pathname: "download-details",
                      state: { data: location.state.data ? location.state.data : null }
                    }
                  );
                }
              }
            })
          }
        })
      }
      else {
        this.setState({
          dateFormat: true,
          errorMsg: "Enter Valid ",
        })
      }
    }
    else {
      this.setState({
        error: true,
        errorMsg: "Enter Your ",
      })
    }

  }
  

  handleKeyPressWhiteSpace = e => {
    const charCode = e.which ? e.which : e.keyCode;
    var name = e.target.name
    if ((charCode == 32 && this.state[name] <= 0)) {
      e.preventDefault();
      return false;
    }
    return true;
  };

  render() {

   
    const { pageContent, loading, location } = this.props;

    if (!pageContent) {
      if (location.state.data.serviceType === "guest") {
        return <Redirect to="/privacy/your-data/guest-landing" />;
      } else if (location.state.data.serviceType === "former") {
        return <Redirect to="/privacy/your-data/former-customer" />;
      }
    }
 
    if (loading) {
      return <RectangleLoader id="formerLoader" />;
    }

    const {
      genericList: [{ list: inputList }],
      buttons
    } = pageContent;
  
    let inputFlag = false;
    

    if ((location.state && location.state.data.isOptOut && location.state.data.isOptOut === "Y") ||
      (location.state && location.state.data.serviceType && location.state.data.serviceType === "guest")) {
      inputFlag = true
    } else {
      inputFlag = false
    }
    return (
     
      <Fragment>
        <div>
          <Container>
            {/* VDS DPCMP-3786 ,DPCMP-3784 */}

          <TitleLockup
              viewport={isMobile ? "mobile": "desktop"}
              data={{
                  title: {
                      size: 'titleXLarge',
                      bold: false,
                            // primitive: 'h1',
                      children: pageContent.section_title
                    },
                  subtitle : {
                      size: 'titleMedium',
                      children: 
                        <div className="subContent">
                           {convertStringToElements(pageContent.section_description)}            
                        </div>
                        }                  
                        }}
           />
           
            <Div>
              <div className="flexContainer">
                {/* FirstName INput */}
                <InputContainer >
                  {/* <Label
                  // htmlFor={jsonValue}
                  >
                    {inputList[0].jsonKey}
                  </Label> */}

                  <Input 
                    type="text"
                    label={inputList[0].jsonKey}
                    aria-label="firstname"
                    data-testId={inputList[0].jsonValue}
                    id={inputList[0].jsonValue}
                    name={"firstname"}
                    data-qm-encrypt="true"
                    error={inputFlag && this.state.error && !this.state.firstname}
                    readOnly={false}
                    value={inputFlag ? this.state.firstname : location.state && location.state.data.fname ? location.state.data.fname : ""}
                    autoComplete="off"
                    onChange={(e) => {
                      if (inputFlag) {
                        this.onChangeText(e)
                      }
                    }}
                    // className={inputFlag && this.state.error && !this.state.firstname ? "icon" : ""}
                    // disabled={location.state && location.state.data.fname ? true : false}
                    onKeyPress={this.handleKeyPressWhiteSpace}
                  />
                  {inputFlag && this.state.error && !this.state.firstname && (
                    <ErrorMsg role="alert" id={`${inputList[0].jsonValue}_error`}>
                      {this.state.errorMsg + "firstname"}
                    </ErrorMsg>
                  )}
                </InputContainer>
                {/* LastName INput */}
                <InputContainer>
                  {/* <Label
                  // htmlFor={jsonValue}
                  >
                    {inputList[1].jsonKey}
                  </Label> */}

                  <Input aria-label="lastname"
                    name={"lastname"}
                    type="text"
                    label={inputList[1].jsonKey}
                    data-testId={inputList[1].jsonValue}
                    data-qm-encrypt="true"
                    value={inputFlag ? this.state.lastname : location.state && location.state.data.lname ? location.state.data.lname : ""}
                    error={inputFlag && this.state.error && !this.state.lastname}
                    readOnly={false}
                    autoComplete="off"
                    onChange={(e) => {
                      if (inputFlag) {
                        this.onChangeText(e)
                      }
                    }}
                    // className={inputFlag && this.state.error && !this.state.lastname ? "icon" : ""}
                    // disabled={location.state && location.state.data.lname ? true : false}
                    onKeyPress={this.handleKeyPressWhiteSpace}
                  />
                  
                  {inputFlag && this.state.error && !this.state.lastname && (
                    <ErrorMsg role="alert" id={`${inputList[1].jsonValue}_error`}>
                      {this.state.errorMsg + "lastname"}
                    </ErrorMsg>
                  )}
                </InputContainer>
              </div>


              {/* Street address INput */}

              <div className="flexContainer" >
                <InputContainer>
                  {/* <Label>
                    {inputList[2].jsonKey}
                  </Label> */}

                  <Input 
                    aria-label="Streetaddress"
                    name={"streetaddress"}
                    label={inputList[2].jsonKey}
                    data-testId={inputList[2].jsonValue}
                    type="text"
                    value={this.state.streetaddress}
                    data-qm-encrypt="true"
                    error={this.state.error && !this.state.streetaddress ? true : false}
                    errorText={this.state.error && !this.state.streetaddress ? this.state.errorMsg + "Street Address" : ""}
                    readOnly={false}
                    disabled={false}
                    autoComplete="off"
                    onChange={(e) => this.onChangeText(e)}
                    // className={this.state.error && !this.state.streetaddress ? "icon" : ""}
                    onKeyPress={this.handleKeyPressWhiteSpace}
                  />
                  {/* {this.state.error && !this.state.streetaddress && (
                    <ErrorMsg role="alert" id={`${inputList[2].jsonValue}_error`}>
                      {this.state.errorMsg + "Street Address"}
                    </ErrorMsg>
                  )} */}
                </InputContainer>

                {/* Apartment NO Input */}

                <InputContainer className="WebViewContainer">
                  {/* <Label>
                    {inputList[3].jsonKey}
                  </Label> */}

                  <Input aria-label="apartment"
                    data-testId={inputList[3].jsonValue}
                    name={"apartment"}
                    type="text"
                    label={inputList[3].jsonKey}
                    value={this.state.apartment}
                    data-qm-encrypt="true"
                    required={false}
                    readOnly={false}
                    disabled={false}
                    error={false}
                    autoComplete="off"
                    onChange={(e) => this.onChangeText(e)}
                    className={""}
                    onKeyPress={this.handleKeyPressWhiteSpace}
                  />
                </InputContainer>
              </div>

              {/* city Input */}
              <div className="flexContainer">
                <InputContainer className="WebViewContainer">
                  {/* <Label>
                    {inputList[4].jsonKey}
                  </Label> */}
                         
                  <Input aria-label="city"
                    name={"city"}
                    data-testId={inputList[4].jsonValue}
                    type="text"
                    label={inputList[4].jsonKey}
                    value={this.state.city}
                    data-qm-encrypt="true"
                    error={this.state.error && !this.state.city ? true : false}
                    errorText={this.state.error && !this.state.city ? this.state.errorMsg + "City" : ""}
                    autoComplete="off"
                    onChange={(e) => this.onChangeText(e)}
                    // className={this.state.error && !this.state.city ? "icon" : ""}
                    onKeyPress={this.handleKeyPressWhiteSpace}
                  />
                  {/* {this.state.error && !this.state.city && (
                    <ErrorMsg role="alert" id={`${inputList[4].jsonValue}_error`}>
                      {this.state.errorMsg + "City"}
                    </ErrorMsg>
                  )} */}
                </InputContainer>

                {/* State  Input */}
                <InputContainer className="WebViewContainer" >
                  {/* <Label>
                    {inputList[5].jsonKey}
                  </Label> */}

                  <DropdownSelect label={inputList[5].jsonKey} ariaLabel="open the dropdown and choose a state"  data-qm-encrypt="true" data-testId={inputList[5].jsonValue} style={{ backgroundColor: this.state.error && !this.state.state ? "#FBE4D7" : "",
                     border: this.state.error && !this.state.state ? "1px solid  #C44904" : "" }} value={this.state.state} name={"state"} onChange={(e) => this.onChangeText(e)}>
                    {pageContent.genericList[1].list.map(appealReaon => (
                      <option ariaLabel={appealReaon.jsonKey} key={appealReaon.jsonKey} value={appealReaon.jsonValue}>
                        {appealReaon.jsonValue}
                      </option>
                    ))}
                  </DropdownSelect>
                  {this.state.error && !this.state.state && (
                    <ErrorMsg role="alert" id={`${inputList[5].jsonValue}_error`}>
                      {"Please Select any State"}
                    </ErrorMsg>
                  )}
                  
                </InputContainer>
              </div>



              {/* *******************************Mobile View start************************************* */}

              {/* Apartment Input */}
              <div className="mobileView">
                <InputContainer className="mobileViewContainer">
                  {/* <Label>
                    {inputList[3].jsonKey}
                  </Label> */}

                  <Input aria-label="apartment"
                    data-testId={"mobileView"+inputList[3].jsonValue}
                    name={"apartment"}
                    type="text"
                    label={inputList[3].jsonKey}
                    value={this.state.apartment}
                    data-qm-encrypt="true"
                    required={false}
                    error={false}
                    style={{ width: "90%" }}
                    autoComplete="off"
                    onChange={this.onChangeText}
                    onKeyPress={this.handleKeyPressWhiteSpace}
                    className={""}
                  />
                </InputContainer>

                {/* city Input */}
                <InputContainer className="mobileViewContainer">
                  {/* <Label>
                    {inputList[4].jsonKey}
                  </Label> */}

                  <Input aria-label="city"
                    name={"city"}
                    data-testId={inputList[4].jsonValue}
                    type="text"
                    label={inputList[4].jsonKey}
                    value={this.state.city}
                    data-qm-encrypt="true"
                    error={this.state.error && !this.state.city ? true : false}
                    errorText={this.state.error && !this.state.city ? this.state.errorMsg + "City" : ""}
                    autoComplete="off"
                    onChange={this.onChangeText}
                    // className={this.state.error && !this.state.city ? "icon" : ""}
                    onKeyPress={this.handleKeyPressWhiteSpace}
                  />
                  {/* {this.state.error && !this.state.city && (
                    <ErrorMsg role="alert" id={`${inputList[4].jsonValue}_error`}>
                      {this.state.errorMsg + "City"}
                    </ErrorMsg>
                  )} */}
                </InputContainer>
              </div>

              <div className="mobileView">

                {/* state Input */}
                <InputContainer className="mobileViewContainer">
                  {/* <Label>
                    {inputList[5].jsonKey}
                  </Label> */}

                  <DropdownSelect label= {inputList[5].jsonKey} data-qm-encrypt="true" width={'220px'} aria-label="open the dropdown and choose a state"  data-testId={inputList[5].jsonValue} style={{ backgroundColor: this.state.error && !this.state.state ? "#FBE4D7" : "", border: this.state.error && !this.state.state ? "1px solid  #C44904" : "" }} name={"state"} value={this.state.state} onChange={(e) => this.onChangeText(e)}>
                    {pageContent.genericList[1].list.map(appealReaon => (
                      <option key={appealReaon.jsonKey} value={appealReaon.jsonValue} >
                        {appealReaon.jsonValue}
                      </option>
                    ))}
                  </DropdownSelect>
                  {this.state.error && !this.state.state && (
                    <ErrorMsg role="alert" id={`${inputList[5].jsonValue}_error`}>
                      {"Please Select any State"}
                    </ErrorMsg>
                  )}
                </InputContainer>

                {/* zipcode Input */}

                <InputContainer className="mobileViewContainer">
                  {/* <Label>
                    {inputList[6].jsonKey}
                  </Label> */}

                  <Input aria-label="zipcode"
                    label= {inputList[6].jsonKey}
                    data-testId={inputList[6].jsonValue}
                    name={"zipcode"}
                    maxLength="5"
                    type="text"
                    data-qm-encrypt="true"
                    value={this.state.zipcode} //inputList[6].jsonValue
                    error={(this.state.error && !this.state.zipcode) || (this.state.zipcode && this.state.zipcode.length !=5) ? true : false}
                    errorText={this.state.error && !this.state.zipcode ? this.state.errorMsg + inputList[6].jsonKey : this.state.zipcode && this.state.zipcode.length != 5 ? "please enter 5 digit " + inputList[6].jsonKey : ""}                    autoComplete="off"
                    onKeyPress={this.handleKeyPress}
                    onChange={(e) =>this.onChangeText(e)}
                    // className={this.state.error && !this.state.zipcode ? "icon" : ""}
                  />
                  {/* {this.state.error && !this.state.zipcode && (
                    <ErrorMsg role="alert" id={`${inputList[6].jsonValue}_error`}>
                      {this.state.errorMsg + inputList[6].jsonKey}
                    </ErrorMsg>
                  )}
                  {this.state.zipcode && this.state.zipcode.length != 5 && (
                    <ErrorMsg role="alert" id={`${inputList[6].jsonValue}_error`}>
                      {"please enter 5 digit " + inputList[6].jsonKey}
                    </ErrorMsg>
                  )} */}
                </InputContainer>
              </div>
              {/* *******************************Mobile View End************************************* */}

              {/* {zipCode Input} */}
              <div className="flexContainer">
                <InputContainer className="WebViewContainer">
                  {/* <Label>
                    {inputList[6].jsonKey}
                  </Label> */}

                  <Input aria-label="zipcode"
                    data-testId={inputList[6].jsonValue}
                    name={"zipcode"}
                    maxLength="5"
                    type="text"
                    label={inputList[6].jsonKey}
                    data-qm-encrypt="true"
                    value={this.state.zipcode}
                    error={(this.state.error && !this.state.zipcode) || (this.state.zipcode && this.state.zipcode.length !=5) ? true : false}
                    errorText={this.state.error && !this.state.zipcode ? this.state.errorMsg + inputList[6].jsonKey : this.state.zipcode && this.state.zipcode.length != 5 ? "please enter 5 digit " + inputList[6].jsonKey : ""}
                    autoComplete="off"
                    onChange={ this.onChangeText}
                    onKeyPress={this.handleKeyPress}
                    // className={this.state.error && !this.state.zipcode ? "icon" : ""}
                  />
                  {/* {this.state.error && !this.state.zipcode && (
                    <ErrorMsg role="alert" id={`${inputList[6].jsonValue}_error`}>
                      {this.state.errorMsg + inputList[6].jsonKey}
                    </ErrorMsg>
                  )}
                  {this.state.zipcode && this.state.zipcode.length != 5 && (
                    <ErrorMsg role="alert" id={`${inputList[6].jsonValue}_error`}>
                      {"please enter 5 digit " + inputList[6].jsonKey}
                    </ErrorMsg>
                  )} */}
                </InputContainer>

                {/* DOB Input */}

                <InputContainer >
                  {/* <Label>
                    {inputList[7].jsonKey}
                  </Label> */}

                  <Input 
                    aria-label=" enter the date of birth"
                    data-testId={inputList[7].jsonValue}
                    name={"dob"}
                    maxLength="10"
                    type="date"
                    required={true}
                    data-qm-block="true"
                    disabled={false}
                    readOnly={false}
                    label={inputList[7].jsonKey}
                    value={this.state.dob} //inputList[7].jsonValue
                    error={(this.state.error && !this.state.dob) ||(this.state.dateFormat && this.state.dob) ? true : false}
                    errorText={(this.state.error && !this.state.dob) || (this.state.dateFormat && this.state.dob)? this.state.errorMsg + "date of birth" : ""}
                    autoComplete="off"
                    onChange={(e) => this.onChangeText(e)}
                    // className={this.state.error && !this.state.dob || this.state.dateFormat ? "icon" : ""}
                    onKeyPress={this.handleKeyPressWhiteSpace}
                  />
                  {/* {this.state.error && !this.state.dob && (
                    <ErrorMsg role="alert" id={`${inputList[7].jsonValue}_error`}>
                      {this.state.errorMsg + "date of birth"}
                    </ErrorMsg>
                  )} */}
                  {/* {this.state.dateFormat && this.state.dob && (
                    <ErrorMsg role="alert" id={`${inputList[7].jsonValue}_error`}>
                      {this.state.errorMsg + "date of birth"}
                    </ErrorMsg>
                  )} */}
                </InputContainer>
              </div>
              <div className="ButtonContainer">
                <Button
                  onClick={() => this.handleClick()}
                  background={"#0000"}

                >
                  {pageContent.buttons[0].text}
                </Button>
              </div>
            </Div>
          </Container>
          {this.props.error ? (
            <Alert alertType="error">{convertStringToElements(this.props.error)}</Alert>
          ) : null}
        </div>
      </Fragment>
    );
  }
}

FormerCustomerDetails.propTypes = {
  setA11yContent: PropTypes.func.isRequired,
  pageContent: PropTypes.object
};

const mapStateToProps = ({ pageContent,
  loadingAndErrorState,
  formerCustomer: { formerId, accountInfo },
  caseCreation: { caseId },
  getUuid: { uuid }
}) => ({
  pageContent: pageContent.address_dob,
  loading: loadingAndErrorState.loading,
  error: loadingAndErrorState.error,
  formerId,
  accountInfo,
  caseId,
  uuid
});

export default compose(
  connect(
    mapStateToProps,
    { setA11yContent, createUpdateProfile, addressDobUpdate }
  ), FetchPageContent
)(FormerCustomerDetails);

const Button = styled(ReactButton)`
  margin-right: 28px;

  ${media.mobile`
    margin-right: 0;
  `}
`;


const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
  margin: "0";
    padding: 48px 16px ;
  `}
`;

const H1 = styled.h1`
width:596px
font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
font-style: normal;
font-weight: 300;
font-size: 48px;
line-height: 48px;

}

  ${media.mobile`
   max-width: 100%;
   font-style: normal;
   font-weight: 400;
   font-size: 32px;
  line-height: 36px;
`}

`;

const Div = styled.div`
div.subContent {
  max-width: 595px;
  height:40px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
   font-style: normal;
  font-weight: 400;
  font-size: 16px;
  focus-visible:true;
  line-height: 20px;
  margin-top: 32px;
  p {

    margin-bottom: 16px;
  }
  
 
  ${media.mobile`
  max-width: 100%;
  font-size: 16px;
  height:60px;
`}
}
 div.ButtonContainer {
    margin-top:48px;
    outline-offset: 4px;

    
   }
 div.select{
    color:black
    }
    
 
  }
  }
 
  div.flexContainer {
    width:580px;
    display:flex;
    focus-visible:true;
    

    ${media.mobile`
    display:block;
    width:100%;
    .WebViewContainer{
      display: none;
      outline:2px solid #000000;
      cursor: pointer;
      focus-visible:true;
      outline-offset: 4px;


    }   
    
`}

${media.tablet`
    gap:20px;
  `};
  }
  div.mobileView{
    display:none;
    max-width: 580px;
    gap:30px;
    ${media.mobile`
    display:flex;  
`}
  }
`;

// const StyledInput = styled(Input)`
//   width: 90%;
//   max-width: 580px;

//   ${media.mobile`
//     width: 100%;
//   `}
// `;
const InputContainer = styled.div`
  flex: 50%;
  margin-top: 32px;
  box-sizing: border-box;
  padding-right: 20px;
  div {
    display: flex;
    align-items:stretch;
  }
  
  .icon {
    padding-left: 25px;
    background: url(${Warning})no-repeat left;
    background-size: 20px;
    background-position: 99%;
    border: 1px solid  #C44904;
    background-color:#FBE4D7;
  }

  
  ${media.mobile`
    flex: 100%;
    margin-top: 12px;
    margin-bottom:20px;
  `}
`;


// const Label = styled(CommonLabel)`
// font-family: 'Verizon-NHG-eTX', Helvetica, Arial, sans-serif;
// font-style: normal;
// font-weight: 400;
// font-size: 12px;
// line-height: 16px;
// color:background: #000000;
// ${media.mobile`
 
// `}
// `;



const ErrorMsg = styled.span`
  display: block;
  font-size: 10px;
  line-height: 15px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  max-width: 173px;
  margin-top: 5px;
  position:absolute;
  color:black;
  ${media.mobile`
    max-width: 100%;  
  `}
`;

// const DropdownSelect = styled(ReactSelect)`
//   width: 90%;
//   padding: 12px !important;
//   min-width: inherit !important;
//   height: inherit !important;
//   border: 1px solid #6F7171;
//   &: focus {
//     outline:2px solid #000000;
//   }
//   ${media.mobile`
//       width: 90%;  
//   `}

// `;



